import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const ProductSelectionSkeleton: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <div className={className} style={style}>
      <TitleSection>
        <SkeletonBlock $width="30%" />
      </TitleSection>
      <ColorsSection data-testid="product-selection-skeleton">
        <SkeletonBlock $width={'48px'} $height={'48px'} />
        <SkeletonBlock $width={'48px'} $height={'48px'} />
        <SkeletonBlock $width={'48px'} $height={'48px'} />
        <SkeletonBlock $width={'48px'} $height={'48px'} />
        <SkeletonBlock $width={'48px'} $height={'48px'} />
      </ColorsSection>
    </div>
  );
};

export const ProductSelectionGridSkeleton: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ({style, className}) => {
  return (
    <div style={style} className={className}>
      <SkeletonBlock $width="30%" />
      <ColorsSectionGrid data-testid="product-selection-skeleton">
        <SkeletonBlock $width={'54px'} $height={'54px'} />
        <SkeletonBlock $width={'54px'} $height={'54px'} />
        <SkeletonBlock $width={'54px'} $height={'54px'} />
        <SkeletonBlock $width={'54px'} $height={'54px'} />
        <SkeletonBlock $width={'54px'} $height={'54px'} />
        <SkeletonBlock $width={'54px'} $height={'54px'} />
      </ColorsSectionGrid>
    </div>
  );
};

const TitleSection = styled.section`
  margin-top: 2rem;
`;

const ColorsSection = styled.section`
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
`;

const ColorsSectionGrid = styled.section`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 6px;
  width: 100%;
`;
